import React from "react";
import {
    ApnDetailsResponse,
    OpportunityInfoResponse,
} from "../../../../../services/oneButtonServices/opportunityValidationService";
import {Table} from "antd";
import {areStringsEqual, renderPairItem, renderStatusIcon} from "./OpportunityValidationShared";

interface ApnInfoProps {
    opportunity: OpportunityInfoResponse;
    apn: ApnDetailsResponse;
}

export const ApnInfo: React.FC<ApnInfoProps> = ({opportunity, apn}) => {

    const columns = [
        {
            title: '',
            dataIndex: 'items',
            width: '30%',
            render: (value: any) => renderPairItem(value[0]),
        },
        {
            title: 'Site X Pro',
            dataIndex: 'items',
            width: '30%',
            render: (value: any) => renderPairItem(value[1]),
        },
        {
            title: '',
            dataIndex: 'items',
            width: '30%',
            render: (value: any) => renderPairItem(value[0]),
        },
        {
            title: '',
            dataIndex: 'status',
            width: '10%',
            align: 'center',
        },
    ];

    const items = [
        {
            items: [
                {
                    name: 'APN',
                    value: opportunity.sfdc.sfdcAPN,
                },
                {
                    name: 'APN',
                    value: apn.siteXproAPN,
                },
            ],
            status: renderStatusIcon(areStringsEqual(
                opportunity.sfdc.sfdcAPN ?? '',
                apn.siteXproAPN ?? '')),
        },
    ];

    return (
        <Table
            size={'small'}
            pagination={false}
            // @ts-ignore
            columns={columns}
            dataSource={items}/>
    );
};